import EducationalProgramsCreationPage from "./EducationalProgramsCreationPage";

export default EducationalProgramsCreationPage